<template>
<div class="table-responsive">    
<table class="table v-middle">
    <thead>
        <tr class="">
            <th class="border-top-0">Аватар</th>
            <th class="border-top-0">Имя, Ник</th>
            <th class="border-top-0">Источник</th>
            <th class="border-top-0">Сообщений</th>
            <th class="border-top-0">Аудитория</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td><img src="https://sun9-67.userapi.com/c857028/v857028018/10726d/BeLBNt1WXxQ.jpg?ava=1" style="border-radius: 10%;width: 30px;"></td>
            <td>Nyura Papina (id520047130)</td>
            <td><h5 class="m-b-0">Вконтакте</h5></td>
            <td><label class="label label-success">29</label></td>
            <td>350</td>
        </tr>
        <tr>
            <td><img src="https://sun1-28.userapi.com/c855520/v855520418/1c1b20/UqdwyhE_gZ8.jpg?ava=1" style="border-radius: 10%;width: 30px;"></td>
            <td>Alexey Chekunov (id189977997)</td>
            <td><h5 class="m-b-0">Вконтакте</h5></td>
            <td><label class="label label-success">13</label></td>
            <td>10</td>
        </tr>
        <tr>
            <td><img src="https://sun9-67.userapi.com/c857028/v857028018/10726d/BeLBNt1WXxQ.jpg?ava=1" style="border-radius: 10%;width: 30px;"></td>
            <td>Nyura Papina (id520047130)</td>
            <td><h5 class="m-b-0">Вконтакте</h5></td>
            <td><label class="label label-success">20</label></td>
            <td>569</td>
        </tr>
        <tr>
            <td><img src="https://sun9-70.userapi.com/c840427/v840427630/8d0fd/TXf4FDU1L68.jpg?ava=1" style="border-radius: 10%;width: 30px;"></td>
            <td>Katenka Isaeva (id18577205)</td>
            <td><h5 class="m-b-0">Вконтакте</h5></td>
            <td><label class="label label-success">13</label></td>
            <td>1736</td>
        </tr>
        <tr>
            <td><img src="https://sun1-18.userapi.com/c852120/v852120226/1ee768/Vn-oyGWEEF4.jpg?ava=1" style="border-radius: 10%;width: 30px;"></td>
            <td>Zaur Mammadov (id550183881)</td>
            <td><h5 class="m-b-0">Вконтакте</h5></td>
            <td><label class="label label-success">12</label></td>
            <td>26</td>
        </tr>
        <tr>
            <td><img src="https://sun1-30.userapi.com/c851232/v851232263/154456/lfg7KoUtoJA.jpg?ava=1" style="border-radius: 10%;width: 30px;"></td>
            <td>Альфа-Банк (club23242408)</td>
            <td><h5 class="m-b-0">Вконтакте</h5></td>
            <td><label class="label label-success">12</label></td>
            <td>178783</td>
        </tr>
        <tr>
            <td><img src="https://sun9-47.userapi.com/c858020/v858020920/fd85d/rpWnpvXpeoo.jpg?ava=1" style="border-radius: 10%;width: 30px;"></td>
            <td>Anya Gavrilina (id403322925)</td>
            <td><h5 class="m-b-0">Вконтакте</h5></td>
            <td><label class="label label-success">11</label></td>
            <td>60</td>
        </tr>
        <tr>
            <td><img src="https://sun1-28.userapi.com/c858432/v858432081/bccc6/4M3NonnhEQQ.jpg?ava=1" style="border-radius: 10%;width: 30px;"></td>
            <td>Ismail Shirinzade (id292036742)</td>
            <td><h5 class="m-b-0">Вконтакте</h5></td>
            <td><label class="label label-success">10</label></td>
            <td>10</td>
        </tr>
         
         
    </tbody>
</table>
</div>
</template>
<script>
export default {
    name: "TopProducts"
}
</script>
